"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDocument = void 0;
const format_1 = require("../format");
function validateDocument(document) {
    const docnumber = (0, format_1.formatStringToNumber)(document);
    if ((0, format_1.isRepeatedDigitText)(docnumber)) {
        return false;
    }
    return true;
}
exports.validateDocument = validateDocument;
